
var zrUtil = require("zrender/lib/core/util");
var Region = require("../Region");

// 解决南海诸岛九段线问题 & 钓鱼岛问题
var geoCoord = [126, 25];
var points = [
    [
      [
        122.04711914062499,
        25.661333498952683
      ],
      [
        122.01965332031249,
        25.611809521055477
      ],
      [
        122.091064453125,
        25.596948323286135
      ],
      [
        122.11303710937499,
        25.656382025768067
      ],
      [
        122.04711914062499,
        25.661333498952683
      ]
    ],
    [[122.50662231445312, 23.467723846435547], [122.78874206542969, 24.572216033935547]],
    [[121.17402648925781, 20.826547622680664], [121.91168975830078, 21.6975154876709]],
    [[120.003662109375, 19.03096327846469], [119.47631835937499, 18.020527657852337]]
];
function _default(mapType, regions) {
    if (mapType === 'china') {
        regions.push(new Region('', zrUtil.map(points, function (exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), geoCoord));
    }
}

module.exports = _default;
